import React from 'react'

import Header from '../../components/Header'

import Img11 from '../../assets/ilustracao_tela11.png'

import { Container, Content, Line } from './styles'

const End: React.FC = () => {
  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>
            Pronto! Seu pedido de adesão ao Plano ASPPrev foi salvo com sucesso!
          </strong>

          <img src={Img11} alt="img11" />

          <p>
            Vamos avaliar seus dados e em breve você receberá a confirmação da
            adesão ao plano da ASPPrev por e-mail!
          </p>
          <Line />
          <div>
            <strong>Acesse o nosso site:</strong>
            <a href="https://aspprev.com.br/">www.aspprev.com.br</a>
          </div>
        </Content>
      </Container>
    </>
  )
}

export default End
